import { Type } from '@angular/core';
import { AutomationActionType } from '@kinet-open-network/shared/data-access/model';
import { ActionComponent } from './abstract-action.component';
import { AddTagActionComponent } from './add-tag-action.component';
import { AiPromptActionComponent } from './ai-prompt-action.component';
import { RemoveTagActionComponent } from './remove-tag-action.component';

export type AutomationActionBuilders = {
  [ActionType in AutomationActionType]: Type<ActionComponent<ActionType>>;
};

const ACTION_MAP: Partial<
  Record<AutomationActionType, Type<ActionComponent<any>>>
> = {
  add_tag: AddTagActionComponent,
  remove_tag: RemoveTagActionComponent,
  ai_prompt: AiPromptActionComponent,
};

export default ACTION_MAP;
